<template>
  <a class="item ripple" href="#" @click.prevent="$emit('click')">
    <img :src="icono" :class="clase" class="img-bg" />
    <div>
      <div class="titulo">{{ titulo }}</div>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    icono: {
      type: String,
      required: true,
    },
    titulo: {
      type: String,
      required: true,
    },
    subtitulo: {
      type: String,
      required: false,
      default: null,
    },
    clase: {
      type: String,
      required: false,
      default: "poliza",
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  margin-bottom: 0.9rem;
}

.titulo {
  color: #ddd;
  font-weight: 500;
}

div {
  :hover {
    color: #38b6ff;
  }
}

.img-bg {
  margin-left: 5px;
  margin-right: 10px;
  width: 1.7rem;
  /*background-color: darken($azulClaroMMT, 10%);*/
  border-radius: 50%;
}

.sini {
  background-color: $naranjaMMT;
  border: 1px solid $naranjaMMT !important;
}

a {
  text-decoration: none;
}
</style>
